import Vue from 'vue';
import Vuex from 'vuex';
import { clearExclusiveCustomerImgCache } from '@/utils/exclusiveCustomerImg';

Vue.use(Vuex);

const STORAGE_KEYS = {
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  userInfo: 'userInfo',
  isLogin: 'isLogin',
  expireTime: 'expireTime'
};

const getDefaultState = () => ({
  isLogin: JSON.parse(localStorage.getItem(STORAGE_KEYS.isLogin) || 'false'),
  expireTime: localStorage.getItem(STORAGE_KEYS.expireTime) || '',
  headerActive: '',
  tradeIndex: '1',
  accessToken: localStorage.getItem(STORAGE_KEYS.accessToken) || '',
  refreshToken: localStorage.getItem(STORAGE_KEYS.refreshToken) || '',
  userInfo: JSON.parse(localStorage.getItem(STORAGE_KEYS.userInfo) || 'null')
});

const store = new Vuex.Store({
  state: getDefaultState(),

  mutations: {
    SET_ACCESS_TOKEN(state, token) {
      state.accessToken = token;
      localStorage.setItem(STORAGE_KEYS.accessToken, token);
    },
    SET_REFRESH_TOKEN(state, token) {
      state.refreshToken = token;
      localStorage.setItem(STORAGE_KEYS.refreshToken, token);
    },
    SET_USER_INFO(state, info) {
      state.userInfo = info;
      localStorage.setItem(STORAGE_KEYS.userInfo, JSON.stringify(info));
    },
    CLEAR_USER(state) {
      state.accessToken = '';
      state.refreshToken = '';
      state.userInfo = null;
      state.isLogin = false;
      state.expireTime = '';
      Object.values(STORAGE_KEYS).forEach(key => localStorage.removeItem(key));
    },
    SET_IS_LOGIN(state, isLogin) {
      state.isLogin = isLogin;
      localStorage.setItem(STORAGE_KEYS.isLogin, isLogin);
    },
    SET_EXPIRE_TIME(state, expireTime) {
      const timestamp = Date.now() + (expireTime - 60) * 1000;
      state.expireTime = timestamp;
      localStorage.setItem(STORAGE_KEYS.expireTime, JSON.stringify(timestamp));
    },
    SET_SHARED_DATA(state, value) {
      state.headerActive = value;
    },
    SET_TRADE_INDEX(state, value) {
      state.tradeIndex = value;
    }
  },

  actions: {
    saveLoginInfo({ commit }, { accessToken, refreshToken, ...userInfo }) {
      commit('SET_ACCESS_TOKEN', accessToken);
      commit('SET_REFRESH_TOKEN', refreshToken);
      commit('SET_USER_INFO', userInfo);
      commit('SET_IS_LOGIN', true);
    },
    logout({ commit }) {
      clearExclusiveCustomerImgCache();
      commit('CLEAR_USER');
      location.href = '/';
    },
    updateSharedData({ commit }, value) {
      commit('SET_SHARED_DATA', value);
    },
    updateTradeData({ commit }, value) {
      commit('SET_TRADE_INDEX', value);
    }
  },

  getters: {
    getUserInfo: state => state.userInfo,
    getAccessToken: state => state.accessToken,
    getRefreshToken: state => state.refreshToken,
    getExpireTime: state => state.expireTime,
    getIsLogin: state => state.isLogin,
    getHeaderActive: state => state.headerActive,
    getTradeIndex: state => state.tradeIndex
  }
});

export default store;
